import {
    ActivitiesSearchPageMobileActivitiesContextManifestV6,
    ActivitiesSearchPageMobileActivitiesContextFieldsV6,
    ActivitiesSearchPageMobileActivitiesContextIdsV6,
} from '@agoda/analytics-messages-definition-activities/manifest/activities-search-page-mobile';
import { WebAnalyticsBinder } from 'core/messaging/analytics/ActivitiesAppDataContext';
import { getSearchPageContextFields } from 'core/messaging/analytics/pages/search';

export const searchPageMobileBinder: WebAnalyticsBinder = (webAnalytics) => {
    webAnalytics.pageContext<ActivitiesSearchPageMobileActivitiesContextIdsV6, ActivitiesSearchPageMobileActivitiesContextFieldsV6>(
        ActivitiesSearchPageMobileActivitiesContextManifestV6.ids,
        getSearchPageContextFields(),
    );
};
